import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

export default function groupInvitedContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.groupInvited"
      values={{
        name: util.getEventNames(events ?? []),
        group: ownerGroup?.name || "Deleted",
      }}
    />
  );
}
